import { useQuery } from "@tanstack/vue-query";
import Subscription from "@/services/billing/subscription";

export interface BillingPlan {
  id: string;
  name: string;
  monthlyCents: number;
  annualCents: number | null;
  stripePriceIdMonthly: string | null;
  stripePriceIdAnnual: string | null;
  features: unknown;
}

export function useBillingPlans() {
  return useQuery({
    queryKey: ["billing", "planCatalog"] as const,
    queryFn: async (): Promise<BillingPlan[]> => {
      const result = await Subscription.getPlanCatalog();
      const payload = result?.data as { status?: boolean; data?: BillingPlan[] };
      if (payload?.status && Array.isArray(payload.data)) return payload.data;
      return [];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
